import React, { useEffect, useRef, useState } from "react";
import Source from "../../../Source";
import axios from "axios";
import Swal from "sweetalert2";
import Profile from "../../../assets/icon/profile.png";
import IdNational from "../../../assets/icon/national_id.png";
import Datepicker_Customer from "../../forms/Datepicker_customer";
import moment from "moment-jalaali";
import jalaali from "jalaali-js";
import Combo_stock from "../../forms/Combo_Customer";
import Combo_stockps from "../../psbox/Combo_Customer";
import Combo_item from "../../forms/Combo_Customer";
import Additem from "./AddItem";
import Money from "../../Money";
// import AddCustomer from '../../assets/icon/AddCustomer.png';
import Add_customer from "../../AddAccount";
import Combo_Customer from "../../forms/Combo_Customer";
// import { useMyContext } from "../../constext/UseContext";
import ComboBox from "../../forms/ComboBox";
import Trash from "../../../assets/icon/trash.png";
import Print from "../../../assets/icon/print.png";
import Add from "../../../assets/icon/add.png";
// import Combo_stock from "../../forms/Combo_stock";
import { useSelector, useDispatch, createDispatchHook } from 'react-redux';
import { getCustomers } from "../../Redux/customerSlice";
import { showAlert } from "../../../warrper";
import AddAddress from "../../../assets/icon/address.png";
import { FormattedMessage } from "react-intl";

import jsPDF from "jspdf";
import { getSettings } from "../../Redux/settingSlice";
import { useShowAlert  } from "../../../warrper";
export default function EditSell({
  AddSellModal,
  close,
  records,
  setRecords,
  moneys,
  // setAddAccountModal,
  Customer,
  setCustomer,
  shopingcart,
  setshopingcart,
  options1, setOptions1,Exesting,setExesting
}) { 
  // console.log(options1)
  const showAlert = useShowAlert(); 
  const dispatch=useDispatch();
  const { customers, errorc, statusc } = useSelector((state) => state.customers);
const { settings, errors, statuss } = useSelector((state) => state.settings);
// const [setting,setsetting] = useState(settings);
useEffect(() => {
  // بررسی و بارگذاری `belances`
  // if (!statusb && belances) {
  //   dispatch(getBelances());
  // }

  // // بررسی و بارگذاری `moneys`
  // if (!statusm && moneys) {
  //   dispatch(getMoneys());
  // }

  // بررسی و بارگذاری `customers`
  // if (!statusc  && !customers) {
  //   dispatch(getCustomers());
  // }

  if(!statuss && !settings) {
    dispatch(getSettings());
  }
}, [dispatch, statusc]);


  const [AddAccountModal,setAddAccountModal]=useState(true);
  const [selectedDay, setSelectedDay] = useState(moment());
  const [selectedDay1, setSelectedDay1] = useState(moment());
  const [selectedOption, setSelectedOption] = useState({name:''});
  const [selectedOption1, setSelectedOption1] = useState({
    name: "",
    type: { measuring: "" },
  });

  useEffect(()=>{
    if(Customer){
      setSelectedOption({name:Customer.accounts ? Customer.accounts.account.name: Customer.temp_customer});
      setSelectedOptionmoney(Customer.money);
      setSelectedDay(moment(Customer.Inserdate));
      setTotalAmount(Customer.total);
      setPaidAmount(Customer.PaidAmount);
    }
    
  },[Customer])

  const [EndDate, setEndDate] = useState(moment());
  const [account, setaccount] = useState(false);
  const [update, setupdate] = useState({ id: 0, belance: 0 });
  const [selectedOptionAccount, setSelectedOptionAccount] = useState([]);
  const [AddItem, setAddItem] = useState({
    item_id: "",
    qty: 0,
    weight: 0,
    dateInsert: new Date().toISOString(),
    rate: 0,
    user_id: localStorage.getItem("userTokenid"),
    purchase_price: 0,
    description: "Description",
    sell_price: 0,
    expiry_date: new Date().toISOString(),
    accounts_id: "",
    money: "",
    stock: { name: "" },
    e_id: 1,
  });
//   const [shopingcart, setshopingcart] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
    const [edit,setEdit]=useState(false);
  const Onsearch = (e) => {
    if (e) {
      setupdate({
        ...update,
        id: e.id,
      });
      setAddItem({
        ...AddItem,
        money: e.type_id,
      });
    }
  };
  const algorithm = (e) => {
    setSelectedOption(e);
    if (e) {
      setAddItem({
        ...AddItem,
        accounts_id: e.id,
      });
    }
  };
    const generateInvoicePDF = (id) => {
      // Function to format date (with Persian date support)
      const dateObj = new Date(selectedDay);
      let formattedDate = `${dateObj.getFullYear()}-${String(
          dateObj.getMonth() + 1
      ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      let aa = ampm;
  
      if (settings[0].date === "Persian") {
          moment.locale("fa");
          formattedDate = moment(selectedDay).format("jYYYY/jMM/jDD");
      } else {
          moment.locale("en");
      }
      formattedDate = `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
  
      // Get the company image URL
      const imageUrl = settings[0]?.company_pic;
      let imageSrc = "";
      if (imageUrl) {
          const fileName = imageUrl.split("/").pop();
          imageSrc = Source.getAddress() + "/api/getImage/" + fileName;
      }
  
      // Generate the HTML content
      const invoiceHTML = `
      <html>
          <head>
              <title>Invoice</title>
              <style>
                  body {
                      font-family: Helvetica, sans-serif;
                      font-size: 12px;
                  }
  
                  .invoice-container {
                      width: 210mm;
                      height: auto;
                      padding: 10mm;
                      box-sizing: border-box;
                      background: #fff;
                  }
  
                  .header {
                      text-align: center;
                      margin-bottom: 20px;
                  }
  
                  .invoice-details {
                      margin-bottom: 15px;
                  }
  
                  table {
                      width: 100%;
                      border-collapse: collapse;
                      border: 1px solid #000;
                  }
  
                  th,
                  td {
                      border: 1px solid #000;
                      padding: 5px;
                      text-align: left;
                  }
  
                  th {
                      background-color: rgb(11, 105, 255);
                      color: #fff;
                      font-size: 12px;
                  }
  
                  td {
                      font-size: 12px;
                      color: #000;
                  }
  
                  .amount-details {
                      text-align: right;
                      margin-bottom: 20px;
                  }
  
                  .footer {
                      text-align: center;
                  }
  
                  .logo {
                      position: absolute;
                      top: 10px;
                      right: 10px;
                      width: 30mm;
                  }
  
                  .even-row {
                      background-color: #f5f5f5;
                  }
  
                  .odd-row {
                      background-color: #fff;
                  }
              </style>
          </head>
  
          <body>
              <div class="invoice-container">
                  <div class="header">
                      <h1 style="font-size: 26px; font-weight: bold; color: rgb(11,105,255); margin: 0;">Invoice</h1>
                      <h2 style="font-size: 14px; margin: 5px 0; color: #000;">${settings[0].company_name}</h2>
                      </div>
                      
                      <div class="invoice-details">
                      <p style="font-size: 12px; margin: 0;">Customer Name: ${selectedOption ? capitalizeWords(selectedOption.name) : "N/A"}</p>
                      <p style="font-size: 14px; color: rgb(11,105,255); margin: 0;">Invoice Number: ${id}</p>
                      <p style="font-size: 12px; margin: 0;">Date: ${formattedDate}</p>
                  </div>
  
                  <hr style="border: 0; border-top: 1px solid #000; margin-bottom: 15px;">
  
                  <div style="margin-bottom: 20px;">
                      <table style="width: 100%; border-collapse: collapse;" border="1" cellspacing="0" cellpadding="5">
                          <thead style="background-color: rgb(11,105,255); font-size: 12px;">
                              <tr>
                                  <th>No</th>
                                  <th>Name</th>
                                  <th>Quantity</th>
                                  <th>Price</th>
                                  <th>Total</th>
                              </tr>
                          </thead>
                          <tbody style="font-size: 12px; color: #000;">
                              ${shopingcart
                                  .map(
                                      (row, index) => `
                                      <tr class="${index % 2 === 0 ? 'odd-row' : 'even-row'}">
                                          <td>${index}</td>
                                          <td>${row.stock.name}</td>
                                          <td>${row.qty}</td>
                                          <td>${row.sell_price} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</td>
                                          <td>${row.sell_price * row.qty} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</td>
                                      </tr>
                                  `
                                  )
                                  .join("")}
                          </tbody>
                      </table>
                  </div>
  
                  <div class="amount-details">
                      <p style="margin: 0;">Total Amount: ${TotalAmount} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                      <p style="margin: 0;">Paid Amount: ${PaidAmount ? PaidAmount : "0.00"} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                      <p style="margin: 0;">Balance: ${update.belance} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                  </div>
  
                  <hr style="border: 0; border-top: 1px solid #000; margin-bottom: 15px;">
  
                  <div class="footer">
                      <p style="margin: 0;">Address: ${settings[0].address}</p>
                      <p style="margin: 0;">Phone: ${settings[0].phone}</p>
                      <p style="margin: 0;">Email: ${settings[0].email}</p>
                  </div>
                   ${imageSrc ? `<img class="logo"  src="${imageSrc}" alt="Company Logo"/>` : ''}
              </div>
          </body>
      </html>
  `;
  
  
  
      // Open a new tab/window
      const printWindow = window.open('', '_blank');
      if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(invoiceHTML);
          printWindow.document.close();
  
          // Wait for content to load in the new window
          printWindow.onload = () => {
              printWindow.focus(); // Focus on the new window
              printWindow.print(); // Open the print dialog
              printWindow.close(); // Close the new window
          };
      } else {
          alert('Please allow pop-ups for this website to print the invoice.');
      }
  };
  const algorithm1 = (e) => {
    setSelectedOption1(e);
    if (e) {
      setAddItem({
        ...AddItem,
        item_id: e.id,
        stock: e,
      });
    }
  };
  const handle_date = (jalaliDate) => {
    if (jalaliDate) {
      const { year, month, day } = jalaliDate;
      const gregorianDate = jalaali.toGregorian(year, month, day);
      // Get current time
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      // Create the ISO date string
      let isoDateString;
      const t = new Date();
      const date = new Date(
        jalaliDate.year,
        jalaliDate.month - 1,
        jalaliDate.day,
        t.getHours(),
        t.getMinutes()
      );

      // const date = new Date(jalaliDate.year, jalaliDate.month - 1, jalaliDate.day);
      const isoString = date.toISOString(); // This gives you the ISO string in UTC
      // setIsoDate(isoString);
      setAddItem({
        ...AddItem,
        dateInsert: isoString,
      });
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  };
  const handle_date1 = (jalaliDate) => {
    if (jalaliDate) {
      const { year, month, day } = jalaliDate;
      const gregorianDate = jalaali.toGregorian(year, month, day);
      // Get current time
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      // Create the ISO date string
      let isoDateString;
      const t = new Date();
      const date = new Date(
        jalaliDate.year,
        jalaliDate.month - 1,
        jalaliDate.day,
        t.getHours(),
        t.getMinutes()
      );

      // const date = new Date(jalaliDate.year, jalaliDate.month - 1, jalaliDate.day);
      const isoString = date.toISOString(); // This gives you the ISO string in UTC
      // setIsoDate(isoString);
      setAddItem({
        ...AddItem,
        expiry_date: isoString,
      });
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  };
  // console.log(shopingcart.length);
  const Sumbit=()=>{
    if (
      selectedOption &&
      AddItem.money &&
      shopingcart.length<=0
    ) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "You must fill the item input!",
                            title: <FormattedMessage id="You must fill the item input!" />,
        showConfirmButton: false,
        timer: 1000,
      });
      return;}
    // }
    // if (update.belance < 0) {
    //   showAlert({
    //     position: "top-end",
    //     icon: "error",
    //     title: "You don't have enough money!",
    //     showConfirmButton: false,
    //     timer: 1000,
    //   });
    //   return;
    // }
    let arr=[];
    shopingcart.forEach((key) => {
      arr.push({
        item_id: key.item_id,
        qty: key.qty,
        weight: key.weight,
        dateInsert: key.dateInsert,
        rate: key.rate,
        user_id: key.user_id,
        sell_price: key.sell_price,
        description: key.description,
        expiry_date: key.expiry_date,
        bill_id:key.bill_id||null,
        accounts_id: key.accounts_id,
      })
    });
    let add={arr:arr,
      _method:"put"
    }
    // console.log(selectedOptionmoney.id||0);
    
    axios
      .post(Source.getAddress() + "/api/sell/"+Customer.id,add, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        params: {
          $type:'edit',
          Bill_id:Customer.id,
          prevMoney:Customer.money_id,
          primaryTotalAmount: Customer.total,
          primaryPaidAmount: Customer.PaidAmount,
          Accounts_id:Customer.accounts_id||'0',
          Exesting: Exesting ? "ok" : "no",
          money:selectedOptionmoney.id||0,
          accounts_id:selectedOption.id ,
          PaidAmount:PaidAmount ? PaidAmount : 0,
          TotalAmount:TotalAmount,
          CustomerName:selectedOption.name,
          DateInsert:shopingcart[0].dateInsert
        },
      })
      .then((res) => {
        console.log(res);
        let BillId=0;
        res.data.bill["money"] = selectedOptionmoney;
        res.data.bill["accounts"] = { account: selectedOption };
        let add = {
          sells: shopingcart,
          bill: res.data.bill,
          accounts: res.data.belance,
        };
        setRecords(prevRecords =>
          prevRecords.map(record =>
            record.bill.id === res.data.bill.id ? add : record
          ));
        showAlert({
          position: "top-end",
          icon: "success",
                              title: <FormattedMessage id="Your record has been updated!" />,
          showConfirmButton: false,
          timer: 1000,
        });})
        .catch((err)=>{
          console.log(err);
          showAlert({
                    position: "top-end",
                    icon: "error",
                    // title: "Something went wrong!",
                    title: <FormattedMessage id="Not working ,please try again!" />,
                    showConfirmButton: false,
                    timer: 1000,
                  });
        })
  }
  const AddtoTable = () => {
      // بررسی اینکه تمام فیلدهای ضروری پر شده‌اند
      if (!AddItem.qty) {
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Select an item!",
                  title:  <FormattedMessage id="Select an item!" />,
          showConfirmButton: false,
          timer: 1000,
        });
        return;
      }
      const qty = AddItem.qty ? parseInt(AddItem.qty) : 0;
      console.log(parseInt(selectedOption1.qty) - qty);
      const sellPrice = AddItem.sell_price ? parseFloat(AddItem.sell_price) : 0;
      if (parseInt(selectedOption1.qty) - qty < 0) {
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "have not enuagh item!",
                  title:  <FormattedMessage id="have not enuagh item!" />,
          showConfirmButton: false,
          timer: 1000,
        });
        return;
      }
      if (!qty || !sellPrice || !selectedOption1) {
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Please select an item and fill the quantity and price!",
                                    title:  <FormattedMessage id="Please select an item and fill the quantity and price!" />,
          showConfirmButton: false,
          timer: 1000,
        });
        return;
      }
  
      // اطمینان از مقدار مثبت برای موجودی
      if (qty <= 0 || sellPrice <= 0) {
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Quantity and price must be positive values!",
          title:  <FormattedMessage id="Quantity and price must be positive values!" />,
          showConfirmButton: false,
          timer: 1000,
        });
        return;
      }
  
      // ایجاد نسخه کپی از AddItem و selectedOption1
      const addto = { ...AddItem, item: { ...selectedOption1 } };
      addto.item.qty = selectedOption1.qty
        ? qty - parseInt(selectedOption1.qty)
        : qty;
        let nextId=shopingcart.length > 0 ? shopingcart[shopingcart.length-1].id +1 :1 ;
        addto.id=nextId;
      // افزودن آیتم به سبد خرید
      setshopingcart((prev) => [...prev, addto]);
  
      // به‌روزرسانی مقادیر کل
      setPaidAmount((prev) => prev + qty * sellPrice);
      setTotalAmount((prev) => prev + qty * sellPrice);
  
      // بازنشانی مقدار AddItem
      setAddItem({
        stocks_id: "",
        qty: "",
        weight: null,
        dateInsert: new Date().toISOString(),
        rate: null,
        user_id: localStorage.getItem("userTokenid"),
        purchase_price: "",
        description: "",
        sell_price: null,
        expiry_date: new Date().toISOString(),
        accounts_id: "",
        money: "",
        stock: { name: "" },
        e_id: AddItem.e_id + 1,
      });
  
      // بازنشانی selectedOption1
      setSelectedOption1(null);
    };
  const handleItem = (e) => {
    setAddItem({
      ...AddItem,
      [e.target.name]: e.target.value,
    });
  };

  const [options, setOptions] = useState(customers);
  // const [options1, setOptions1] = useState([]);
  const handleSearch = async (query) => {
    if(!Exesting){
      if(query){
        setAddItem({
          ...AddItem,
          temp_customer:query
        })
        setSelectedOption({id:1,name:query});
      }}
    // }
  };
  const capitalizeWords = (text) => {
    return text
      .toLowerCase() // همه حروف را کوچک کنید
      .split(" ") // متن را به آرایه‌ای از کلمات تقسیم کنید
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // حروف اول هر کلمه را بزرگ کنید
      .join(" "); // کلمات را به هم وصل کنید
  };
  const handleSearch1 = async (query) => {
    // if (query.length < 3) {
    //   // برای جلوگیری از ارسال درخواست بیش از حد، درخواست فقط اگر ورودی بیشتر از 2 حرف باشد ارسال شود
    //   setOptions1([]);
    //   return;
    // }
    // try {
    //   const response = await axios.get(`${Source.getAddress()}/api/item`, {
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem("access")}`,
    //     },
    //     params: {
    //       query: query,
    //     }, // ارسال پارامتر جستجو به سرور
    //   });
    //   const data = response.data;
    //   // console.log(data);
    //   // تبدیل داده‌ها به فرمت مناسب برای react-select
    //   const formattedOptions = data;
    //   //    data.map((customer) => ({
    //   //     id: customer.id,
    //   //     name: customer.name,
    //   //     customer
    //   //   }));
    //   setOptions1(formattedOptions);
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // } finally {
    // }
  };
  const handleInputChange = (newValue) => {
    setSearchQuery(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch(newValue); // ارسال درخواست جستجو به سرور
  };
  const handleInputChange1 = (newValue) => {
    setSearchQuery1(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch1(newValue); // ارسال درخواست جستجو به سرور
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");

  const [selectedOptionmoney, setSelectedOptionmoney] = useState({ name: "" });
  const algorithmmoney = (e) => {
    if (e) {
      setAddItem({
        ...AddItem,
        money: e.id,
      });
    }
  };

  const Deleteshopingcart = (e) => {
    setPaidAmount((prev) => prev - e.qty * e.sell_price);
    setTotalAmount((prev) => prev - e.qty * e.sell_price);
    setshopingcart((prev) => prev.filter((pre) => pre.id !== e.id));
  };
  const buttonRef = useRef(null);
const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    if (buttonRef.current && AddSellModal) {
      buttonRef.current.click();
    }
  }
}
const  [PaidAmount,setPaidAmount]=useState();
const handlepaid=(e)=>{
  setPaidAmount(e.target.value);
};
useEffect(() => {
  // if (PaidAmount) {
    // const total = Number(TotalAmount) || 0;
    // const paid = Number(PaidAmount) || 0;
    if(!PaidAmount){
      setupdate((prevState) => ({
        ...prevState,
        belance: -TotalAmount,
      }));  
    }
    else{
      setupdate((prevState) => ({
        ...prevState,
        belance: PaidAmount - TotalAmount ||0 ,
      }));
    }
    
  // }
}, [PaidAmount, TotalAmount,shopingcart]);
useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(`${Source.getAddress()}/api/customers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        params: { query:searchQuery ,do:'ok'}, // ارسال پارامتر جستجو به سرور
      });
      // setSelectedOption(response.data);
      const data = response.data;
      setOptions(data);
      // console.log('hhi');

      // if (data && data.length === 0) {
      //   setSelectedOptionTo({ id: 0, name: searchQueryTo });
      // } else {
      //   setOptionsTo(data); // ذخیره داده‌ها برای نمایش در لیست
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  if(searchQuery){
    if (!searchQuery || searchQuery?.length < 3) {
      setOptions([]);
      return;
    }else{
  if (Exesting) {
      fetchData();}
    }
  }
}, [searchQuery]); // اضافه کردن searchQuery به وابستگی‌های useEffect

  return (
    <div
  dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
  className={`container rounded-5 popup transition ${account && "sellpurchase"} ${AddSellModal ? "show" : ""}`}
  style={{
    width: "95%",
    maxWidth: "95%",
    height: "75vh",
    backgroundColor: "#f8f9fa",
    padding: "5px",
    zIndex: 1000,
    fontSize: "0.8rem"
  }}
>
  {/* Header */}
  <div className="d-flex justify-content-end align-items-center mt-2">
    <h2 className="text-center rounded p-1 text-light m-0" style={{
      backgroundColor: "var(--bs-info)",
      width: "100%",
      fontSize: "0.9rem"
    }}>
      <FormattedMessage id="Bill" />
    </h2>
    <button
      type="button"
      className="btn-close p-2 mt-0 hover_btn"
      onClick={close}
      aria-label="Close"
    />
  </div>

  {/* Main Content */}
  <div className="p-1 rounded-5">
    <div style={{ marginTop: "0.5rem", overflow: "auto" }}>
      {/* Customer Info Section */}
      <div className="rounded-3 px-3 p-1 mb-2 " style={{
        // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)"
        boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
      }}>
        <h2 className="mt-1 mb-2" style={{ fontSize: "0.85rem" }}>
          <FormattedMessage id="Customer Info" />
        </h2>
        <div className="d-flex flex-column flex-md-row mb-2">
          <div className="form-check form-switch p-0 center mb-2 me-2" style={{ width: "5rem", height: "1rem" }}>
            <label className="fw-bold" style={{ fontSize: "0.8rem" }}>
              <FormattedMessage id="Exesting" />
            </label>
            <input
              className="form-check-input align-bottom m-0 w-100 h-75 mt-1 ms-1"
              type="checkbox"
              checked={Exesting}
              onChange={(e) => setExesting(e.target.checked)}
            />
          </div>
          
          <div className="form-item me-2 w-100 w-md-auto">
            <label className="fw-bold" style={{ fontSize: "0.8rem" }}>
              <FormattedMessage id="Customer Name" />
            </label>
            <Combo_stock
              name={"Add Seller"}
              setAddAccountModal={setAddAccountModal}
              type={Exesting}
              searchQuery={searchQuery}
              handleInputChange={handleInputChange}
              setSelectedOption={algorithm}
              selectedOption={selectedOption}
              options={options}
              compactMode={true}
            />
          </div>
          
          <div className="form-item me-2 w-100 w-md-auto">
            <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              <FormattedMessage id="Currency" />
            </label>
            <Combo_Customer
              isEditable={account}
              setSelectedOption={setSelectedOptionmoney}
              selectedOption={selectedOptionmoney}
              options={moneys}
              Onsearch={algorithmmoney}
              compactMode={true}
            />
          </div>
          
          <div className="date-picker-container w-100 w-md-auto">
            <Datepicker_Customer
              default_value={EndDate}
              handle_date={handle_date}
              lebal={<FormattedMessage id="Date" />}
              setSelectedDay={setSelectedDay}
              selectedDay={selectedDay}
              compactMode={true}
            />
          </div>
        </div>
      </div>

      {/* Item Information Section */}
      <div className="rounded-3 px-3 p-1 mb-2" style={{
        // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)"
        boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
      }}>
        <h2 className="mt-1 mb-2" style={{ fontSize: "0.85rem" }}>
          <FormattedMessage id="Item information" />
        </h2>
        <div className="d-flex flex-column flex-md-row mb-2">
          <div className="me-2 w-100 w-md-auto">
            <label className="fw-bold" style={{ fontSize: "0.8rem" }}>
              <FormattedMessage id="Item Name" />
            </label>
            <Combo_stockps
              searchQuery={searchQuery1}
              setSearchQuery={setSearchQuery1}
              handleInputChange={handleInputChange1}
              handleSearch={handleSearch1}
              setSelectedOption={algorithm1}
              selectedOption={selectedOption1}
              options={options1}
              compactMode={true}
            />
          </div>
          <div className="me-2 w-100 w-md-5rem">
            <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              <FormattedMessage id="Quantity" />
            </label>
            <input
              onKeyDown={handleKeyDown}
              onChange={handleItem}
              value={AddItem.qty}
              type="number"
              name="qty"
              className="form-control mb-1"
              style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
            />
          </div>
          
          <div className="me-2 w-100 w-md-6rem">
            <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              <FormattedMessage id="Sell Price" />
            </label>
            <input
              onKeyDown={handleKeyDown}
              onChange={handleItem}
              value={AddItem.sell_price}
              type="number"
              name="sell_price"
              className="form-control mb-1"
              style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
            />
          </div>
          <div className="me-2 w-100 w-md-7rem">
            <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              <FormattedMessage id="Total Amount" />
            </label>
            <input
              readOnly
              value={AddItem.qty * AddItem.sell_price}
              type="text"
              className="form-control mb-1"
              style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
            />
          </div>
          <div className="me-2 w-100 w-md-5rem">
            <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              <FormattedMessage id="Rate" />
            </label>
            <input
              onKeyDown={handleKeyDown}
              onChange={handleItem}
              value={AddItem.rate}
              type="number"
              className="form-control mb-1"
              style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
            />
          </div>
          
          {selectedOption1?.type?.measuring?.includes("Weight") && (
            <div className="me-2 w-100 w-md-6rem">
              <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                <FormattedMessage id="Weight" />
              </label>
              <input
                onChange={handleItem}
                type="number"
                name="weight"
                className="form-control mb-1"
                style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
              />
            </div>
          )}
          <button
            onClick={AddtoTable}
            type="button"
            className="btn btn-success p-1 mb-1 w-100 w-md-5rem mt-3 h-25"
            style={{ fontSize: "0.8rem" }}
          >
            <img src={Add} style={{ width: "15px", height: "15px" }} alt="Add" />
          </button>
        </div>
      </div>
    </div>
  </div>

  {/* Bottom Section */}
  <div className="row m-0 p-0">
    {/* Items Table */}
    <div className="col-12 col-md-8">
      <div style={{ maxHeight: '300px', overflow: "auto" }}>
        <h3 className="text-center rounded p-1 text-light m-0 mb-1" style={{
          backgroundColor: "var(--bs-info)",
          fontSize: "0.85rem"
        }}>
          <FormattedMessage id="Purchase Stock" />
        </h3>
        <div className="table-responsive">
          <table className="table table-light table-striped" style={{ fontSize: "0.8rem" }}>
            <thead>
              <tr>
                <th scope="col" style={{ width: "5%" }}><FormattedMessage id="No" /></th>
                <th scope="col" style={{ width: "25%" }}><FormattedMessage id="Name" /></th>
                <th scope="col" style={{ width: "15%" }}><FormattedMessage id="Quantity" /></th>
                <th scope="col" style={{ width: "15%" }}><FormattedMessage id="Price" /></th>
                <th scope="col" style={{ width: "15%" }}><FormattedMessage id="Total" /></th>
                <th scope="col" style={{ width: "5%" }}><FormattedMessage id="Delete" /></th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {shopingcart?.map((row, idx) => (
                <tr key={idx}>
                  <th scope="row">{row.id}</th>
                  <td>{row.stock.name}</td>
                  <td>{row.qty}</td>
                  <td>{row.sell_price}</td>
                  <td>{row.sell_price * row.qty}</td>
                  <td>
                    <button
                      style={{ border: "none", background: "transparent", padding: "0" }}
                      onClick={() => Deleteshopingcart(row)}
                    >
                      <img height="15px" width="15px" src={Trash} alt="Delete" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Payment Section */}
    <div className="col-12 col-md-4">
      <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
        <FormattedMessage id="Total Amount" />
      </label>
      <input
        readOnly
        onChange={handleItem}
        value={TotalAmount}
        type="text"
        className="form-control mb-1"
        style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
      />
      
      <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
        <FormattedMessage id="Paid Amount" />
      </label>
      <input
        onKeyDown={handleKeyDown}
        onChange={handlepaid}
        value={PaidAmount}
        type="text"
        className="form-control mb-1"
        style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
      />
      
      <label style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
        <FormattedMessage id="Remain Amount" />
      </label>
      <input
        readOnly
        value={update.belance}
        type="number"
        className="form-control mb-2"
        style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
      />
      
      <div className="d-flex justify-content-center mt-3">
        <button
          type="button"
          className="btn btn-danger text-light me-1 ms-1"
          style={{ width: "100px", fontSize: "0.8rem", padding: "0.2rem" }}
          onClick={() => {
            close();
            setEdit(false);
          }}
        >
          <FormattedMessage id="Cancel" />
        </button>
        <button
          type="button"
          className="btn btn-success text-light ms-1"
          style={{ width: "100px", fontSize: "0.8rem", padding: "0.2rem" }}
          onClick={() => generateInvoicePDF(Customer.id)}
        >
          <FormattedMessage id="Print" />
        </button>
        {edit ? (
          <button
            type="button"
            className="btn btn-success text-light ms-1"
            style={{ width: "100px", fontSize: "0.8rem", padding: "0.2rem" }}
            onClick={Sumbit}
          >
            <FormattedMessage id="Save" />
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary text-light ms-1"
            style={{ width: "100px", fontSize: "0.8rem", padding: "0.2rem" }}
            onClick={() => setEdit(true)}
          >
            <FormattedMessage id="Edit" />
          </button>
        )}
      </div>
    </div>
  </div>
</div>
  );
}